const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const ANON_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || '';

const sendUserData = async (body: Record<string, any>): Promise<Record<string, any> | null> => {
    if (!body) return null;

    try {
        const data = await fetch(`${SUPABASE_URL}/rest/v1/results`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                apiKey: ANON_KEY,
            },
            body: JSON.stringify(body),
        });

        return data;
    } catch {
        return null;
    }
};

export default sendUserData;
